import Spinner from 'components/spinner/spinner.component';
import { useAwaitRecaptcha } from 'hooks/recaptcha';

const AwaitRecaptcha = ({ children }) => {
  const loaded = useAwaitRecaptcha();

  return loaded ? <>{children}</> : <Spinner />;
};
export default AwaitRecaptcha;
